import { PalmettoButton, PalmettoIcon } from '@palmetto/dsm-components';

import { CustomerDirectPaymentPage } from './CustomerDirectPaymentPage';

function handleReload() {
  window.location.reload();
}

export function CustomerDirectPaymentError() {
  return (
    <CustomerDirectPaymentPage>
      {/* Main content — top on mobile, centered on desktop */}
      <div className="flex flex-1 items-start justify-center pt-24 lg:items-center lg:pt-40 lg:pb-40">
        <div className="flex w-full max-w-[413px] flex-col items-stretch gap-8 lg:h-[477px]">
          <div
            data-theme="lumen"
            className="flex w-full flex-1 flex-col justify-between gap-32 rounded-16 bg-canvas-error p-24"
          >
            <h2 className="heading-700 text-text-error">
              Uh-oh,
              <br />
              something&apos;s
              <br />
              wrong &ndash; please try
              <br />
              again
            </h2>
            <PalmettoIcon name="warningTriangle" size="2xl" className="text-text-error" />
          </div>
          <PalmettoButton type="button" emphasis="secondary" size="medium" layout="fill" onClick={handleReload}>
            Reload this page
          </PalmettoButton>
        </div>
      </div>
    </CustomerDirectPaymentPage>
  );
}
